const Instagram = (props) => (
  <svg
    width='40'
    height='40'
    viewBox='0 0 40 40'
    fill='#152a46'
    {...props}
    className={props?.color}
  >
    <path d='M34.141,5.859A19.269,19.269,0,0,0,20,0,19.269,19.269,0,0,0,5.859,5.859,19.269,19.269,0,0,0,0,20,19.269,19.269,0,0,0,5.859,34.141,19.269,19.269,0,0,0,20,40a19.269,19.269,0,0,0,14.141-5.859A19.269,19.269,0,0,0,40,20,19.269,19.269,0,0,0,34.141,5.859ZM32.5,31.563a.934.934,0,0,1-.938.938H8.438a.934.934,0,0,1-.938-.938V8.438A.934.934,0,0,1,8.438,7.5H31.563a.934.934,0,0,1,.938.938ZM16.484,16.484a4.905,4.905,0,0,0,0,7.031,4.905,4.905,0,0,0,7.031,0,4.905,4.905,0,0,0,0-7.031,4.905,4.905,0,0,0-7.031,0ZM25,15h5V10H25Zm2.422,5A7.469,7.469,0,0,1,20,27.422,7.469,7.469,0,0,1,12.578,20a6.722,6.722,0,0,1,.156-1.25H10V30H30V18.75H27.266A6.722,6.722,0,0,1,27.422,20ZM40,37.5' />
    <style jsx>
      {`
        .UA {
          fill: rgb(255, 69, 9) !important;
        }
      `}
    </style>
  </svg>
)

export default Instagram
